import { render, staticRenderFns } from "./workingYear.vue?vue&type=template&id=07271ce2&"
import script from "./workingYear.vue?vue&type=script&lang=js&"
export * from "./workingYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports